import BaseRiseColor from '@/components/BaseRiseColor'
import BaseTooltip from '@/components/BaseTooltip'
import { bigNumberMultipliedBy, formatAddString } from '@/utils/tools'
import type { BasePriceItem } from 'api-price'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { Flex } from '@mantine/core'
import useRateChange from '@/hooks/useRateChange'

const Change: FC<BasePriceItem> = ({ change, low_24h, high_24h, fiat }) => {
  const { t } = useTranslation()
  const { formatRateChangePrice } = useRateChange()

  return (
    <BaseTooltip
      position="top"
      isToolTipState
      label={
        <Flex direction="column" gap={4}>
          <span className="size-12 font-500" style={{ color: '#fff' }}>
            {t('P.HighPrices', {
              prices: `${fiat?.symbol ?? ''}${formatRateChangePrice(
                bigNumberMultipliedBy(high_24h, fiat?.rate ?? '1'),
                { isUnit: !fiat?.symbol }
              )}`,
            })}
          </span>
          <span className="size-12 font-500" style={{ color: '#fff' }}>
            {t('P.LowPrices', {
              prices: `${fiat?.symbol ?? ''}${formatRateChangePrice(bigNumberMultipliedBy(low_24h, fiat?.rate ?? '1'), {
                isUnit: !fiat?.symbol,
              })}`,
            })}
          </span>
        </Flex>
      }
    >
      <BaseRiseColor value={change}>
        <span className="text-1 size-16 font-500">{formatAddString(parseFloat(change))}</span>
      </BaseRiseColor>
    </BaseTooltip>
  )
}

export default observer(Change)
